import React from "react";
import { NavLink } from "react-router-dom";
import { LockKey } from "@phosphor-icons/react";

/**
 * Yellow banner nudging users still inside their MFA-enrollment grace window
 * to enroll before they're blocked from signing in.
 */
export default function MfaGraceBanner({ user }) {
  if (!user?.mfa_policy_required) return null;
  if (user.mfa_enabled) return null;
  if (typeof user.mfa_grace_days_left !== "number") return null;

  const s = user.mfa_grace_days_left === 1 ? "" : "s";
  return (
    <div
      className="bg-yellow-200 border-b-2 border-yellow-600 px-6 py-2 text-xs flex items-center gap-3"
      data-testid="mfa-grace-banner"
    >
      <LockKey size={14} weight="bold" />
      <div className="flex-1">
        <b>MFA required by policy.</b> You have <b>{user.mfa_grace_days_left}</b> day{s} left to
        enroll before you&apos;re blocked from sign-in.
      </div>
      <NavLink
        to="/profile"
        data-testid="mfa-grace-enroll-link"
        className="border border-black bg-black text-white px-3 py-1 uppercase tracking-widest text-[11px] font-bold hover:bg-yellow-600"
      >
        Enroll now
      </NavLink>
    </div>
  );
}
